import { IsOptional, IsString, IsDateString, MaxLength, IsEnum } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { ErasureStatus } from '../enums'

/**
 * DTO pour créer une demande d'effacement RGPD
 */
export class CreateErasureRequestDto {
  @ApiPropertyOptional({ description: 'Raison de la demande', maxLength: 512 })
  @IsOptional()
  @IsString()
  @MaxLength(512)
  reason?: string

  @ApiPropertyOptional({
    description: 'Date limite de traitement',
    type: 'string',
    format: 'date-time',
  })
  @IsOptional()
  @IsDateString()
  deadlineAt?: string
}

/**
 * DTO pour traiter une demande d'effacement (admin)
 */
export class ProcessErasureDto {
  @ApiProperty({ enum: ErasureStatus, description: 'Nouveau statut' })
  @IsEnum(ErasureStatus)
  status!: ErasureStatus
}
